export default __webpack_public_path__ + "assets/img/empty-classes@2x.png";